import "./setting.css";
import {  useState, useEffect } from "react";
import API from "../../api/axiosConfig";
import { Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton";
import RegisterTextbox from "../../components/RegisterTextBox";
import UploadInput from "../../components/UploadInput";
import SettingTabs from "./SettingTabs";


function GenSetting() {
      const [ user , setUser] = useState({});
    const getRepUser = async () => {
        try {
            const response = await API.get(`/orgusers/representative`);
            const data = await response;
            setUser(data.data);
            //console.log(data.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getRepUser();
    }, []);

   const [formData, setFormData] = useState({
        orgName: user?.organization?.name || "",
        orgPhone: user?.organization?.phone || "",
        orgRegion: user?.organization?.region || "",
        orgCity: user?.organization?.city || "",
        orgRegNum: user?.organization?.registration_number || "",
        orgWhatsapp: user?.organization?.phone || "",
        orgWebsite: user?.organization?.website || "",
    });

    if (!user) {
        return <div>جار تحميل البيانات...</div>;
    }

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
        console.log(formData);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

       return (
        <div className="setting-container">
            <SettingTabs activeTab="general" />

            <Form onSubmit={handleSubmit}>
                <div className="genSrttingContent">
                    <h4 className="lineTitle">بيانات الممثل</h4>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="repName"
                            label="إسم ممثل الجمعية"
                            type="text"
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                            value={user?.name}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="repEmail"
                            label="البريد الإلكتروني للممثل"
                            type="text"
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                            value={user?.email}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="repAddress"
                            label="عنوان الممثل"
                            type="text"
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                            value={user?.address}
                        />
                    </div>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="repPhone"
                            label="رقم جوال الممثل"
                            type="number"
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                            value={user?.phone}
                        />
                       
                    </div>

                <div className="genSrttingContent genSrttingContent2">
                    <h4 className="lineTitle lineTitle2">بيانات الجمعية</h4>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgName"
                            label="إسم الجمعية"
                            type="text"
                            value={formData.orgName}
                            value={user?.organization?.name}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgPhone"
                            label="رقم جوال الجمعية"
                            type="number"
                            value={formData.orgPhone}
                            value={user?.organization?.phone}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgRegion"
                            label="المنطقة"
                            type="text"
                            value={formData.orgRegion}
                            value={user?.organization?.region}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                    </div>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgCity"
                            label="المدينة"
                            type="text"
                            value={formData.orgCity}
                            value={user?.organization?.city}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgRegNum"
                            label="رقم التسجيل"
                            type="text"
                            value={formData.orgRegNum}
                            value={user?.organization?.registration_number}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgSpec"
                            label="التخصص"
                            type="text"
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                            value={user?.organization?.specialization.name}
                        />
                    </div>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgWhatsapp"
                            label="رقم الواتساب"
                            type="number"
                            value={formData.orgWhatsapp}
                            value={user?.organization?.phone}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgTaxNum"
                            label="الرقم الضريبي"
                            type="number"
                            value={formData.orgTaxNum}
                            value={user?.organization?.tax_number}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgTaxFile"
                            label="السجل الضريبي"
                            label="السجل التجاري"
                            type="text"
                            value={formData.orgTaxFile}
                            value={user?.organization?.tax_register}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                    </div>
                    <div className="genralSettingRow">
                        <RegisterTextbox
                            parentStyle={{ width: "30%" }}
                            id="orgWebsite"
                            label="الموقع الإلكتروني"
                            type="text"
                            value={formData.orgWebsite}
                            value={user?.organization?.website}
                            onChange={handleChange}
                            stylee={{ width: "45%" }}
                        />
                      
                    </div>
                </div>
                </div>
            </Form>
        </div>
    
    );
}

export default GenSetting;